export default function numberToCurrency(value) {
	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency', currency: 'USD', minimumFractionDigits: 2
	})
	return formatter.format(value)
}
